import { post } from "@/utils/request";

// 访问企查查接口
export function getQiAnswer(str) {
  return post('/tj/company/queryName', {
    id: str,
  })
}
